<template>
  <div class="ScoreResult">
    <div style="text-align: right; padding: 20px 20px 10px;" @click="close">
      <van-icon name="cross" size="14" />
    </div>
    <div v-for="item in result" :key="item.id" style="padding: 20px 10px">
      <div class="scoreHeader">
        <div class="left">
          <p style="font-size: 0.37333rem;">{{ item.name }}</p>
          <p style="color: #969799;font-size: 0.32rem;">{{ item.examTime }}</p>
        </div>
        <div>
          <p :style="{ color: color, fontSize: '0.37333rem' }">{{ item.score === -1 ? '缺考' : item.score }}</p>
        </div>
      </div>
      <div class="scoreBox">
        <p>{{ item.examType }}</p>
        <p v-if="item.pass == 1">您好，您的考试成绩为：“<span :style="{ color: color }">{{ item.score }}</span>分”。恭喜你通过了{{ item.examType }}，成绩合格！感谢您对ALSOLIFE的支持。</p>
        <p v-if="item.pass == 0 && item.score != -1">您好，您的考试成绩为：“<span :style="{ color: color }">{{ item.score }}</span>分”。非常遗憾，您未能通过{{ item.examType }}，继续努力，您还可以参加下一次考试！</p>
        <p v-if="item.score == -1">非常抱歉，您的成绩未能查询出结果，如有疑问，请联系您班级学委。给您带来麻烦，万分抱歉！</p>
      </div>
    </div>
    <div class="scoreBoxNo" v-if="result.length == 0" style="margin: 20px 10px">
      <p>您好，这个身份证号码没有查询到对应的成绩信息，请您重新输入。</p>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'

export default {
  name: 'ScoreResult',
  components: {
    [Icon.name]: Icon
  },
  data() {
    return {
      color: '',
      result: []
    }
  },
  created() {
    localStorage.removeItem('ScoreQuery')
    this.result = JSON.parse(this.$route.query.result)
    this.color = this.$route.query.color
  },
  mounted() {
    if (localStorage.getItem('ScoreResultNum') >= 0) {
      localStorage['ScoreResultNum'] = JSON.parse(localStorage.getItem('ScoreResultNum')) + 1
    } else {
      localStorage['ScoreResultNum'] = 0
    }
  },
  methods: {
    close() { // 返回上一层
      this.$router.go(JSON.parse(localStorage.getItem('ScoreResultNum')) ? -JSON.parse(localStorage.getItem('ScoreResultNum')) : -1)
    }
  }
}
</script>

<style lang="less">
.ScoreResult {
  .scoreHeader{
    margin: 0 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      padding: 0 0 8px;
      p {
        margin: 0;
        padding: 5px 0 5px;
      }
        
    }
  }
  .scoreBox{
    padding: 10px 15px; 
    background: #f7f7f7;
    p {
      font-size: 13px;
      line-height: 20px;
      text-align: left;
    }
  }
  .scoreBoxNo{
    padding: 10px 15px; 
    background: #f7f7f7;
    p {
      font-size: 0.34667rem;
      line-height: 0.53333rem;
      text-align: left;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
